import Blazy from 'blazy';
import InView from 'inview';

document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.body.classList.add('is-loaded');
        
        setTimeout(function() {
            cover.remove();
        }, 250);
        
        
        // B-lazy
        if (document.getElementsByClassName('b-lazy').length > 0) {

          window.bLazy = new Blazy({
            success: function success(el) {
                let item = el.parentNode.parentNode;
                    item.classList.add('is-visible');
                    setTimeout(function () {
                        //el.classList.add('faded-in');
                    }, 1);
                }
          });
        }
        
        const travel = document.getElementsByClassName('js-travelslider')[0],
              reviews = document.getElementsByClassName('js-reviewsslider')[0];
        
        reviews ? window.reviewsSlider() : false;      
        travel ? window.travelSlider() : false;
        
        
        // Video
        const video = document.getElementsByClassName('js-video')[0];
        
        if (video) {
             
             const inview = InView(video, function(isInView) {
                if (isInView) {
                    window.videoInit();
                    this.destroy();
                }
            });
        } 

        // Anims on inview
//        window.animsInit()   

    };
    
    
    window.addEventListener('load', init);

}, false);